// extracted by mini-css-extract-plugin
export default {"DeleteProjectTagDialog":"DeleteProjectTagDialog_DeleteProjectTagDialog__qMytP"};